// TODO-TM: Add missing info for some parameters

import { ParameterCategory, ParameterSubCategory } from './ParameterCategories';

// TODO TM: DOUBLE CHECK IDS NAMES AND GENERAL NOTIONS

export const PARAMETERS_NAMES: Record<string, string> = {
  EMO: 'Emocromo',
  WBC: 'Leucociti (WBC)',
  RBC: 'Eritrociti (RBC)',
  HB: 'Emoglobina (Hb)',
  HCT: 'Eritrociti (HCT)',
  MCV: 'Volume medio dei globuli rossi (MCV)',
  MCH: 'Emoglobina corpuscolare media (MCH)',
  MCHC: 'Concentrazione media di emoglobina (MCHC)',
  RDW: 'Indice di variabilità dei globuli rossi (RDW)',
  PLT: 'Piatcellole (PLT)',
  NEU: 'Neutrofili (NEU)',
  NEU_PERCENTAGE: 'Neutrofili (NEU)%',
  LIN: 'Linfociti (LIN)',
  LIN_PERCENTAGE: 'Linfociti (LIN)%',
  MON: 'Monociti (MON)',
  MON_PERCENTAGE: 'Monociti (MON)%',
  EOS: 'Eosinofili (EOS)',
  EOS_PERCENTAGE: 'Eosinofili (EOS)%',
  BAS: 'Basofili (BAS)',
  BAS_PERCENTAGE: 'Basofili (BAS)%',
  QPE: 'Quoziente di perfusione eritrocitaria (QPE)',
  Alb_PERCENTAGE: 'Albumina (Alb)',
  ALB: 'Albumina (Alb)',
  ALFA1_PERCENTAGE: 'Alfa-1 Globuline %',
  ALFA1: 'Alfa-1 Globuline',
  ALFA2_PERCENTAGE: 'Alfa-2 Globuline %',
  ALFA2: 'Alfa-2 Globuline',
  BETA1_PERCENTAGE: 'Beta-1 Globuline %',
  BETA1: 'Beta-1 Globuline',
  BETA2_PERCENTAGE: 'Beta-2 Globuline %',
  BETA2: 'Beta-2 Globuline',
  GAMMA_PERCENTAGE: 'Gamma Globuline %',
  GAMMA: 'Gamma Globuline',
  ALB_GLO: 'Rapporto Alb/Glo',
  FE: 'Ferro',
  ALT: 'ALT/GPT Alanina aminotransferase ',
  AST: 'ALT/GOT Alanina aminotransferase ',
  ALP: 'ALP Fosfatasi alcalina',
  TOTAL_BILIRUBIN: 'Bilirubina totale',
  DIRECT_BILIRUBIN: 'Bilirubina diretta',
  BILIRUBIN_TOTAL: 'Bilirubina totale',
  BILIRUBIN_DIRECT: 'Bilirubina diretta',
  GGT: 'GGT Gamma glutamil transferasi',
  TOTAL_PROTEINS: 'Proteine totali',
  CRE: 'Creatinina',
  AZO: 'Azo',
  NA: 'Sodio',
  K: 'Potassio',
  CA: 'Calcio',
  P: 'Fosfato',
  CL: 'Cloro',
  HDL: 'Colesterolo HDL',
  TOTAL_CHOLESTEROL: 'Colesterolo totale',
  LDL: 'Colesterolo LDL',
  TRI: 'Trigliceridi',
  LPA: 'Lipoproteina piccola',
  GLI: 'Glicemia',
  INS: 'Insulina',
  HOMA: 'IndiceHOMA',
  HBA1C: 'HbA1c',
  URIC_ACID: 'Acido urico',
  OMO: 'Omocisteina',
  TSH: 'Thyroid Stimulating Hormone',
  FT4: 'Tiroxina libera',
  VITD25OH: 'Vitamina D250H',
  PCR: 'Proteina C Reattiva',
  VES: 'Vitamina di Eritrosedimentazione',
  AMI: 'Amilasi',
  LIP: 'Lipasi',
  CK: 'Creatina Chinasi',
  PSA: 'PSA Reflex',
  FOLIC_ACID: 'Acido folico',
  PTT_SECONDS: 'Tempo di tromboplastina parziale secondi',
  PTT_RATIO: 'Tempo di tromboplastina parziale rapporto',
  LH: 'Ormone luteinizzante',
  FSH: 'Ormone follicolo Stimolante',
  PROL: 'Prolattina',
  VITD3: 'Vitamina D3',
};

export const PARAMETERS_GENERAL_NOTION: Record<string, string> = {
  EMO: `L’emocromo (abbreviazione di esame emocromocitometrico) è uno degli esami del sangue più comuni e importanti.
Fornisce una “fotografia” dettagliata delle cellule presenti nel sangue, permettendo di valutare lo stato di salute generale e di identificare diverse condizioni mediche (infezioni, infiammazioni, anemie,  problemi immunitari, allergie), monitorare terapie e tenere sotto controllo condizioni croniche. 
Le tre prinicipali linee cellulari del sangue analizzate sono: 
1) Globuli rossi o eritrociti responsabili per il trasporto di ossigeno
2) Globuli bianchi o leucociti che difendono l'organismo da infezioni e malattie
3) Le piastrine che sono coinvolte nella coagulazione del sangue

Nell'ambito della salute metabolica ed in particolare di Obesità, diabete e pre-diabete che sono condizioni infiammatorie croniche di basso grado, l’emocromo:
• È una spia silenziosa di infiammazione cronica, stress metabolico, malassorbimenti.
• Può monitorare l’effetto della dieta o dei farmaci.
• Aiuta a prevenire complicanze cardiovascolari e microvascolari.`,
  WBC: `I leucociti sono i globuli bianchi e questo valore indica quanti globuli bianchi sono nel nostro sangue. I globuli bianchi sono responsabili delle nostre difese immunitarie.
 Valori alti possono indicare infezioni, infiammazioni, stress, leucemia o altre patologie.
 Valori bassi possono essere provocati da alcuni farmaci o essere dovuti a infezioni virali, insufficiente funzionamento del midollo, dall'ingrossamento della milza, da malattie del fegato o dall'eccesso di alcol. `,
  RBC: `Gli eritrociti sono i globuli rossi e questo valore indica il  numero totale dei globuli rossi nel nostro sangue.  I globuli rossi sono responsabili per il trasporto di ossigeno e sono le cellule più numerose del sangue, e di tutto il corpo, che contengono l'emoglobina. 
Valori alti possono essere una conseguenza di perdita di liquidi a causa di diarrea, disidratazione o ustioni.
Valori bassi si possono riscontrare in caso di anemia (una carenza di ferro nell'organismo)`,
  HB: `"L'emoglobina è una proteina ferrosa contenuta all'interno dei globuli rossi e che si lega alle molecole di ossigeno e le trasporta ai diversi organi e tessuti del corpo. Questo valore indica la quantità media di emoglobina che trasporta ossigeno nei globuli rossi
E' uno dei  parametri chiave per valutare l’anemia. L'anemia, secondo l'OMS,  l'Organizzazione Mondiale della Sanità, deve considerarsi accertata (diagnosticata) quando i valori di emoglobina nel sangue sono al di sotto di 12 grammi per decilitro (g/dL) nelle donne e di 13,4 g/dL negli uomini.
Valori elevati invece possono indicare disidratazione o ipossia cronica o malattie del sangue più serie quali la policitemia in cui il midollo osseo produce troppi globuli rossi. "`,
  HCT: `"L'ematocrito è la  percentuale di globuli rossi presenti nel volume totale del sangue.
Anche in questo caso valori alti possono essere correlati a disidratazione o policitemia mentre valori bassi possono essere degli indicatori di anemia o eccesso di liquidi. "`,
  MCV: `"L'MCV o Volume corpuscolare medio è il volume medio di ogni globulo rosso presente nel nostro sangue. Questo valore può essere molto utili ad esempio a classificare le tipologie di anemie in microcitica, normocitica o  macrocitica.
 Alterazioni delle caratteristiche fisiche (indici) dei globuli rossi possono essere dovute a cause diverse. 
Ad esempio, un aumento del volume medio corpuscolare (MCV) può essere provocato da una carenza di vitamina B12 o folati, da malattie del fegato, della tiroide o può verificarsi nel periodo della gravidanza.
Valori bassi invece possono indicare carenza di ferro o talassemia."`,
  MCH: `L'MCH indica quanta emoglobina c’è in un singolo globulo rosso e di conseguenza indica quanto ossigeno può effettivamente trasportare ogni singola cellula. 
  Valori alti possono essere indicatori di anemie macrocitiche oppure disfunzioni tiroidee quali ipotiroidismo o abuso di alcool. 
  Valori bassi possono verificarsi in caso  di carenza di ferro o di condizioni infiammatorie o anemia sideropenica. `,
  MCHC: `L'MCHC calcola la percentuale media di emoglobina presente dentro i globuli rossi di conseguenza misura la densità dell'emoglobina all interno dei globuli rossi. 
Valori alti possono essere dovuti a cellule ipercromiche (Più scure del normale) oppure ad altri tipi di anemia quali anemia falciforme. 
Valori bassi possono essere dovuti a carenza di ferro o qualche forma di anemia quale la talassemia. `,
  RDW: `L'RDW o distribuzione del volume eritrocitario misura la variabilità di dimensioni dei globuli rossi ed indica quindi la presenza di globuli rossi di dimensioni molto diverse e può essere  utile per diagnosi di anemie miste.
Valori alti possono essere indicazioni di stress ossidativo. `,
  PLT: `Le piastrine sono le cellule più piccole del sangue umano, che hanno la funzione di favorire la coagulazione e la cicatrizzazione delle ferite da cui fuoriesce sangue (emorragie).
Valori alti possono indicare infiammazione e rischio di trombosi. 
Valori bassi possono indicare rischio emorragico e problemi midollari. `,
  NEU: `I neutrofili sono una tipologia di globulo bianco. I neutrofili rappresentano la componente più abbondante dei leucociti (50-70%) e svolgono un ruolo cruciale nella difesa dell'organismo contro le infezioni batteriche e fungine.`,
  NEU_PERCENTAGE: ``,
  LIN: `I linfociti sono una tipologia di globulo bianco e sono fondamentali per la risposta immunitaria adattativa.`,
  LIN_PERCENTAGE: ``,
  MON: `I monociti sono una tipologia di globulo bianco e costituiscono il 2-8% dei leucociti e sono precursori dei macrofagi. Una volta migrati nei tessuti, si differenziano in macrofagi, cellule con elevata capacità fagocitaria che eliminano agenti patogeni, cellule danneggiate e detriti cellulari.`,
  MON_PERCENTAGE: ``,
  EOS: `Gli eosinofili sono una tipologia di globulo bianco e sono coinvolti nella difesa dell'organismo da alcuni tipi di parassiti e svolgono un ruolo nelle reazioni allergiche. Aumentano anche nelle malattie allergiche come asma bronchiale, rinite allergica e orticaria.`,
  EOS_PERCENTAGE: ``,
  BAS: `I basofili sono una tipologia di globulo bianco. I basofili sono i leucociti meno numerosi (<1%) e sono coinvolti nelle reazioni allergiche e infiammatorie. Rilasciano mediatori chimici come l'istamina, che contribuisce alla vasodilatazione e all'aumento della permeabilità vascolare durante le reazioni allergiche. `,
  BAS_PERCENTAGE: ``,
  QPE: `Il quadro proteico elettroforetico è un esame di laboratorio che analizza le diverse frazioni proteiche presenti nel siero sanguigno, permettendo di identificare eventuali alterazioni indicative di condizioni patologiche. Alterazioni nei livelli di queste frazioni possono indicare diverse condizioni patologiche, come infiammazioni, infezioni, malattie autoimmuni o disturbi epatici. È importante notare che l'elettroforesi delle proteine è un esame semiquantitativo; pertanto, per una valutazione accurata delle singole frazioni proteiche, potrebbero essere necessari ulteriori test specifici. ​

Per una comprensione dettagliata dei risultati del QPE e delle loro implicazioni cliniche, è sempre consigliabile consultare un professionista sanitario qualificato.`,
  ALB_PERCENTAGE: ``,
  ALB: `L'albumina è  la proteina più abbondante nel siero, svolge un ruolo cruciale nel mantenimento della pressione oncotica e nel trasporto di varie sostanze.`,
  ALFA1_PERCENTAGE: ``,
  ALFA1: `Questa frazione comprende proteine come l'alfa-1 antitripsina, che agisce come inibitore delle proteasi e svolge un ruolo nella risposta infiammatoria.`,
  ALFA2_PERCENTAGE: ``,
  ALFA2: `Questa frazione include proteine come l'aptoglobina, che lega l'emoglobina libera nel plasma, e la ceruloplasmina, coinvolta nel trasporto del rame.`,
  BETA1_PERCENTAGE: ``,
  BETA1: `Questa frazione comprende proteine che hanno un ruolo centrale nella risposta immunitraria e di pulizia del plasma da molecole tossiche`,
  BETA2_PERCENTAGE: ``,
  BETA2: `Questa frazione comprende proteine come la transferrina che traporta il ferro nel sangue, lipoproteine a bassa densità (LDL) legate al trasporto del colesterolo e la fibronectina coinvolta nei processi di riparazione tissutale. `,
  GAMMA_PERCENTAGE: ``,
  GAMMA: `Comprendono principalmente le immunoglobuline (anticorpi) coinvolte nella risposta immunitaria dell'organismo.`,
  'ALB/GLO': `Il rapporto albumina/globuline (A/G ratio) è un indice di equilibrio tra le due principali classi proteiche del siero. Il rapporto A/G ci aiuta a valutare l’equilibrio tra la produzione epatica (albumina) e l’attività del sistema immunitario/infiammatorio (globuline).
Un rapporto alto deve far sospettare deficit immunitari o problemi di idratazione o produzione proteica.
Un rapporto basso può nascondere un processo infiammatorio cronico o una patologia epatica.`,
  FE: `La sideremia misura la concentrazione di ferro nel sangue, essenziale per la produzione di emoglobina e il trasporto dell'ossigeno.`,
  ALT: `L'alanina aminotransferasi (ALT) è un enzima presente principalmente nel fegato, coinvolto nel metabolismo degli amminoacidi.`,
  AST: `L'aspartato aminotransferasi (AST) è un enzima presente nel fegato, cuore, muscoli e altri tessuti, anch'esso coinvolto nel metabolismo degli amminoacidi. Un aumento dell'AST può essere associato a danno epatico, infarto miocardico o lesioni muscolari.`,
  ALP: `La fosfatasi alcalina (ALP) è un enzima presente in vari tessuti, con concentrazioni elevate nel fegato, nelle ossa e nei dotti biliari.
Valori alti possono indicare malattie epatiche, ostruzione biliare o disturbi ossei.
Valori bassi sono meno comuni`,
  TOTAL_BILIRUBIN: `La bilirubina è un pigmento giallastro derivato dalla degradazione dell’emoglobina (contenuta nei globuli rossi). Dopo che i globuli rossi “vecchi” vengono smaltiti da fegato e milza, si forma la bilirubina, che passa nel sangue e viene poi eliminata principalmente tramite la bile (quindi attraverso l’intestino).
E' importante misurare la bilirubina totale poiche è un marker precoce di sofferenza epatica (epatiti, cirrosi).


 La bilirubina totale è la somma tra la bilirubina diretta (coniugata) e quella indiretta (non coniugata). 
`,
  DIRECT_BILIRUBIN: `La bilirubina diretta (coniugata) è la bilirubina processata dal fegato e resa idrosolubile. Viene escreta con la bile.
Valori in aumento possono avvenire incaso  di ostruzione delle vie biliari o colestasi.`,
  GGT: `La GGT è un enzima epatico coinvolto nel trasporto degli amminoacidi e nel metabolismo del glutatione, un potente antiossidante.
È presente in molti tessuti, ma in particolare nel fegato, nelle vie biliari, nel rene, nel pancreas e nell’intestino.
La GGT è importante perchè è  un marcatore molto sensibile di danno epatobiliare, cioè di sofferenza del fegato e delle vie biliari.

Valori di GGT elevata possonoessere dovuti a abuso di alcol, uso cronico di farmaci, epatite e cirrosi, colestasi, sindrome metabolica e diabete di tipo 2, fumo e obesità

La GGT è molto sensibile ma poco specifica: può aumentare per molte cause diverse, perciò va sempre interpretata insieme ad altri enzimi epatici (ALT, AST, ALP).`,
  TOTAL_PROTEINS: `Le proteine totali rappresentano la somma di tutte le proteine presenti nel plasma, principalmente:
•Albumina (≈ 60%)
•Globuline (≈ 40%)
Sono importanti per valutare lo stato nutrizionale, controllare patologie epatiche, renali, infiammatorie o tumorali. 

Valori alti possono essere rappresentativi di disidratazione e infiammazioni croniche. 
Valori bassi possono indicare malnutrizione/malassorbimento, patologie epatiche o sindrome nefrosica `,
  CRE: `La creatinina è un prodotto di scarto del metabolismo muscolare (della creatina) ed è escreto dai reni.
È importante perché è uno dei principali indicatori della funzione renale.
Valori elevati possono indicare una ridotta funzionalità renale, disidratazione, ostruzioni urinarie
Valori bassi possono portare ad  una ridotta massa muscolare, possono indicare  diete ipoproteiche o possono essere dovute ad una gravidanza `,
  AZO: `L’urea è il prodotto finale del metabolismo delle proteine, generato nel fegato e eliminato dai reni.
La sua concentrazione nel sangue è chiamata azotemia.
E' importante per valutare la funzione renale e  l'equilibrio proteico-metabolico.
Valori elevati possono indicare ad una insufficienza renale, disidratazione, possono essere dovuti ad una dieta iperproteica o terapie cortisoniche
Valori bassi possono essere dovuti ad una dieta povera di proteine, malattie epatiche gravi che portano ad una ridotta sintesi dell'urea oppure a gravidanza`,
  NA: `Il sodio è un elettrolita essenziale che contribuisce a mantenere l'equilibrio dei liquidi nel corpo, l'equilibrio acido-base e la pressione osmotica dei liquidi corporei.
Valori alti possono portare  a sete intensa ed  irrequietezza
Valori bassi possono causare sintomi come confusione, debolezza e convulsioni.`,
  K: `Il potassio è un minerale cruciale per la funzione muscolare, inclusa quella cardiaca, e per la trasmissione degli impulsi nervosi.
Valori alti possono  causare palpitazioni, nausea e, in casi severi, arresto cardiaco.
Valori bassi possono causare crampi muscolari, debolezza e aritmie cardiache.`,
  CA: `Il calcio è fondamentale per la salute delle ossa e dei denti, la coagulazione del sangue e la funzione neuromuscolare.
Valori alti possono causare nausea, debolezza e calcoli renali 
Valori bassi possono provocare formicolio, spasmi muscolari e osteoporosi a lungo termine`,
  P: `Il fosforo è un minerale presente in quantità significative nell'organismo, con circa l'80% contenuto nel tessuto scheletrico. È coinvolto in diversi metabolismi, tra cui quello osseo, glicidico, lipidico ed energetico. Il suo metabolismo è strettamente correlato a quello del calcio ed è regolato da ormoni come il paratormone (PTH), la calcitonina e la vitamina D. 
Valori alti possono portare a prurito, calcificazioni dei tessuti molli e alterazioni ossee
Valori bassi possono causare debolezza, confusione e problemi ossei`,
  CL: `Il cloro è un elettrolita che, insieme al sodio e al potassio, è necessario per un corretto bilancio idrico, per l'equilibrio acido-base e per il mantenimento della pressione osmotica dei liquidi corporei. 
Valori alti possono essere associati a acidosi metabolica e iperidratazione.
Valori bassi possono causare squilibri acido-base e disidratazione.`,
  TOTAL_CHOLESTEROL: `Il colesterolo totale rappresenta la somma delle diverse frazioni di colesterolo presenti nel sangue, principalmente le lipoproteine a bassa densità (LDL), ad alta densità (HDL) ed in parte i trigliceridi. 
Un livello desiderabile di colesterolo totale è inferiore a 200 mg/dL.
Valori Elevati: Un colesterolo totale elevato può aumentare il rischio di malattie cardiovascolari, come l'aterosclerosi, poiché potrebbe indicare un'elevata quantità di LDL ("colesterolo cattivo").
Valori Bassi: Sebbene meno comune, un colesterolo totale troppo basso potrebbe essere associato a condizioni come malnutrizione o alcune malattie croniche.`,
  HDL: `Il colesterolo HDL è noto come "colesterolo buono" perché aiuta a rimuovere l'eccesso di colesterolo dalle arterie, trasportandolo al fegato per l'eliminazione.
Tendenzialmente un livello superiore a 60 mg/dL è desiderabile in quanto considerato protettivo contro le malattie cardiache.
Valori Bassi: Possono aumentare il rischio di malattie cardiovascolari.`,
  LDL: `Il colesterolo LDL trasporta il colesterolo dal fegato alle cellule. Tuttavia, livelli elevati possono portare all'accumulo di placca nelle arterie.
Tendenzialmente, per individui a basso rischio cardiovascolare, un livello inferiore a 130 mg/dL è considerato ottimale.`,
  TRI: `I trigliceridi sono un tipo di grasso presente nel sangue, derivante principalmente dalla dieta e utilizzato come fonte di energia.`,
  LPA: `La Lp(a) è una variante delle LDL, con una componente proteica aggiuntiva chiamata apolipoproteina(a). I livelli di Lp(a) sono in gran parte determinati geneticamente e non esiste un consenso universale sui valori ottimali. Tuttavia, livelli superiori a 30 mg/dL sono considerati un fattore di rischio aggiuntivo per le malattie cardiovascolari.
Valori Elevati: Aumentano il rischio di aterosclerosi e trombosi.`,
  GLI: `La glicemia a digiuno misura la quantità di glucosio (zucchero) nel sangue dopo almeno 8 ore di digiuno. È il parametro principale per individuare diabete e prediabete.

Valori Elevati possono essere dovuti a Insulino-resistenza, diabete tipo 2, stress, cortisonici e possono causare danno vascolare, renale, neurologico, retinopatia
Valori Bassi possono essere dovuti a digiuno prolungato, insulina eccessiva, errori terapeutici e possono causare tremori, sudorazione, confusione, perdita di coscienza

Secondo NCEP ATP III e IDF, un valore di Glicemia ≥100 mg/dL o diagnosi di diabete tipo 2  è uno dei 3 parametri su 5 necessari che definiscono  la sindrome metabolica assieme a: 
•Circonferenza vita >102 cm (uomini), >88 cm (donne) (ATP III) 
•Trigliceridi ≥150 mg/dL
• HDL <40 mg/dL (uomini), <50 mg/dL (donne)
• Pressione arteriosa ≥130/85 mmHg`,
  INS: `L'insulina è l'ormone che regola la glicemia: fa entrare il glucosio nelle cellule. Valutare l’insulina a digiuno aiuta a capire se il corpo è resistente all'insulina.
Valori elevati possono essere causati da insulino-resistenza, obesità, sindrome metabolica e possono portare ad infiammazione cronica l'aterosclerosi
Valori bassi possono essere causati da Diabete di tipo 1 e possono portare a iperglicemia.
`,
  HOMA: `È un indice di insulino-resistenza calcolato da glicemia e insulina a digiuno. Non è nei criteri formali di diagnosi della sindrome metabolica, ma è ampiamente usato in clinica e ricerca per valutare il rischio metabolico precoce.`,
  HBA1C: `È la percentuale di emoglobina legata al glucosio nel sangue. Riflette la media della glicemia degli ultimi 2-3 mesi. È riconosciuta ufficialmente dall’OMS e ADA (American Diabetes Association)  per la diagnosi di diabete e prediabete.

Valori elevati possono essere indice di Diabete e possono aumentare il rischio di complicanze micro e macro vascolari
Valori bassi sono raramente problematici

Anche se non ancora formalmente integrato nei criteri ATP III o IDF, molti esperti e società scientifiche (es. ADA – American Diabetes Association) accettano HbA1c ≥5.7% come marker equivalente per prediabete e rischio metabolico.

Secondo l’OMS e molte linee guida cliniche europee:
• L’HbA1c può essere usata nella diagnosi precoce di prediabete e diabete
• Ma non ha ancora sostituito ufficialmente la glicemia nei criteri della sindrome metabolica
`,
  URIC_ACID: `L'acido urico è una sostanza prodotta dal metabolismo delle purine, componenti naturali presenti negli alimenti e nelle cellule del nostro corpo. Viene eliminato principalmente attraverso i reni.

Valori Elevati: Può portare alla formazione di cristalli di urato nelle articolazioni, causando la gotta. Inoltre, è associata a un aumento del rischio di calcoli renali e può essere un indicatore di sindrome metabolica.
Valori Bassi: Meno comune, può essere dovuta a malattie epatiche, renali o a una dieta povera di purine.
`,
  OMO: `L'omocisteina è un aminoacido prodotto durante il metabolismo della metionina, un altro aminoacido essenziale. I suoi livelli nel sangue possono riflettere lo stato delle vitamine B6, B12 e dei folati.

Valori Elevati possono essere associati a un aumento del rischio cardiovascolare, poiché può danneggiare le pareti dei vasi sanguigni e favorire la formazione di trombi. Può derivare da carenze vitaminiche, malattie renali o mutazioni genetiche.`,
  TSH: `Il TSH è un ormone prodotto dall'ipofisi che stimola la tiroide a produrre gli ormoni tiroidei T3 e T4, regolando il metabolismo corporeo.
Valori elevati indicano generalmente ipotiroidismo, dove la tiroide non produce sufficienti ormoni, portando a sintomi come affaticamento, aumento di peso e depressione.
Valori bassi invece suggeriscono ipertiroidismo, caratterizzato da una produzione eccessiva di ormoni tiroidei, con sintomi come perdita di peso, nervosismo e tachicardia.`,
  FT4: `La tiroxina libera è la frazione non legata della T4, l'ormone tiroideo principale, attiva nel metabolismo.
Valori elevati indicano ipertiroidismo, con sintomi come perdita di peso, irritabilità e palpitazioni.

Valori bassi invece suggeriscono ipotiroidismo, con sintomi come affaticamento, aumento di peso e pelle secca.`,
  VITD25OH: `La 25-idrossivitamina D è la forma principale di vitamina D circolante nel sangue, utilizzata per valutare lo stato vitaminico D di un individuo.
Valori bassi possono  causare osteomalacia negli adulti e rachitismo nei bambini, aumentando il rischio di fratture ossee.`,
  PCR: `La proteina C reattiva è una proteina prodotta dal fegato in risposta a processi infiammatori.
Valori nella norma sono generalmente inferiori a 10 mg/L

Una PCR elevata può indicare la presenza di un'infiammazione acuta o cronica. Valori superiori a 10 mg/L possono suggerire infezioni o malattie infiammatorie.`,
  VES: `La VES misura la velocità con cui i globuli rossi sedimentano in un campione di sangue, indicando la presenza di infiammazione.

Valori elevati possono indicare infiammazioni, infezioni, malattie autoimmuni o tumori.`,
  AMI: `L'amilasi è un enzima prodotto principalmente dal pancreas e dalle ghiandole salivari, coinvolto nella digestione dei carboidrati.`,
  LIP: `La lipasi è un enzima prodotto dal pancreas che aiuta a digerire i grassi.`,
  CK: `La Creatina Chinasi (CK) è un enzima che catalizza il trasferimento di una molecola di fosfato dal creatinfosfato all'ADP, con formazione di ATP, la principale fonte di energia utilizzata dalle cellule. Le concentrazioni più elevate di questo enzima si trovano nelle cellule dei muscoli scheletrici e del muscolo cardiaco; concentrazioni molto inferiori sono presenti nel cervello, nella muscolatura liscia dell'intestino, nell'utero, nel rene e nella prostata. 

Un aumento dei livelli di CK può indicare danni muscolari, come nella distrofia muscolare, traumi, esercizio fisico intenso o infarto miocardico.
`,
  PSA: `Il PSA (Antigene Prostatico Specifico) è una proteina prodotta dalla prostata. Il test del PSA reflex prevede la misurazione iniziale del PSA totale; se questo risulta elevato, viene automaticamente misurata la frazione libera del PSA (PSA libero) per calcolare il rapporto tra PSA libero e PSA totale, utile nella diagnosi differenziale tra iperplasia prostatica benigna e carcinoma prostatico.`,
  FOLIC_ACID: `L'acido folico è una vitamina del gruppo B necessaria per le funzioni dei globuli rossi e dei globuli bianchi e per la sintesi del DNA in tutte le cellule. È presente in alimenti come uova, latte, vegetali a foglia verde, lieviti, fegato e frutta, e viene anche prodotto dai batteri intestinali; viene immagazzinato nel fegato.`,
  PTT_SECONDS: `Il Tempo di Tromboplastina Parziale (PTT) misura il tempo necessario affinché il sangue coaguli attraverso la via intrinseca della coagulazione.
Può indicare deficit dei fattori della coagulazione, malattie epatiche, carenza di vitamina K o presenza di anticoagulanti circolanti.`,
  PTT_RATIO: `Il rapporto PTT confronta il PTT del paziente con un valore di riferimento, fornendo un indice standardizzato.`,
  LH: `L'Ormone Luteinizzante (LH) è prodotto dall'ipofisi e regola la funzione delle gonadi: nelle donne stimola l'ovulazione e la produzione di progesterone; negli uomini promuove la produzione di testosterone.`,
  FSH: `L'Ormone Follicolo-Stimolante (FSH), prodotto dall'ipofisi, è fondamentale per lo sviluppo delle gonadi: nelle donne stimola la crescita dei follicoli ovarici; negli uomini promuove la spermatogenesi.`,
  PROL: `La Prolattina è un ormone prodotto dall'ipofisi anteriore che stimola la produzione di latte nelle donne dopo il parto e influisce su altre funzioni riproduttive.`,
  VITD3: `La Vitamina D3 è essenziale per l'assorbimento del calcio e la salute delle ossa. Il test misura la 25-idrossivitamina D, la principale forma circolante nel sangue.`,
};

export const PARAMETERS_CATEGORY: Record<string, string> = {
  EMO: ParameterCategory.Hematology,
  WBC: ParameterCategory.Hematology,
  RBC: ParameterCategory.Hematology,
  HB: ParameterCategory.Hematology,
  HCT: ParameterCategory.Hematology,
  MCV: ParameterCategory.Hematology,
  MCH: ParameterCategory.Hematology,
  MCHC: ParameterCategory.Hematology,
  RDW: ParameterCategory.Hematology,
  PLT: ParameterCategory.Hematology,
  NEU: ParameterCategory.Hematology,
  NEU_PERCENTAGE: ParameterCategory.Hematology,
  LIN: ParameterCategory.Hematology,
  LIN_PERCENTAGE: ParameterCategory.Hematology,
  MON: ParameterCategory.Hematology,
  MON_PERCENTAGE: ParameterCategory.Hematology,
  EOS: ParameterCategory.Hematology,
  EOS_PERCENTAGE: ParameterCategory.Hematology,
  BAS: ParameterCategory.Hematology,
  BAS_PERCENTAGE: ParameterCategory.Hematology,
  QPE: ParameterCategory.Hematology,
  Alb_PERCENTAGE: ParameterCategory.Hematology,
  ALB: ParameterCategory.Hematology,
  ALFA1_PERCENTAGE: ParameterCategory.Hematology,
  ALFA1: ParameterCategory.Hematology,
  ALFA2_PERCENTAGE: ParameterCategory.Hematology,
  ALFA2: ParameterCategory.Hematology,
  BETA1_PERCENTAGE: ParameterCategory.Hematology,
  BETA1: ParameterCategory.Hematology,
  BETA2_PERCENTAGE: ParameterCategory.Hematology,
  BETA2: ParameterCategory.Hematology,
  GAMMA_PERCENTAGE: ParameterCategory.Hematology,
  GAMMA: ParameterCategory.Hematology,
  ALB_GLO: ParameterCategory.Hematology,
  FE: ParameterCategory.Hematology,
  ALT: ParameterCategory.LiverAndBiliaryTract,
  AST: ParameterCategory.LiverAndBiliaryTract,
  ALP: ParameterCategory.LiverAndBiliaryTract,
  'Bili.tot': ParameterCategory.LiverAndBiliaryTract,
  'Bili.dir': ParameterCategory.LiverAndBiliaryTract,
  GGT: ParameterCategory.LiverAndBiliaryTract,
  'Prot.Tot': ParameterCategory.LiverAndBiliaryTract,
  CRE: ParameterCategory.Kidneys,
  AZO: ParameterCategory.Kidneys,
  NA: ParameterCategory.Electrolytes,
  K: ParameterCategory.Electrolytes,
  CA: ParameterCategory.Electrolytes,
  P: ParameterCategory.Electrolytes,
  CL: ParameterCategory.Electrolytes,
  'Col.Tot': ParameterCategory.Lipids,
  HDL: ParameterCategory.Lipids,
  LDL: ParameterCategory.Lipids,
  TRI: ParameterCategory.Lipids,
  LPA: ParameterCategory.Lipids,
  GLI: ParameterCategory.GlucoseMetabolismAndInsulinResistance,
  INS: ParameterCategory.GlucoseMetabolismAndInsulinResistance,
  HOMA: ParameterCategory.GlucoseMetabolismAndInsulinResistance,
  HBA1C: ParameterCategory.GlucoseMetabolismAndInsulinResistance,
  'A.URI': ParameterCategory.GlucoseMetabolismAndInsulinResistance,
  OMO: ParameterCategory.GlucoseMetabolismAndInsulinResistance,
  TSH: ParameterCategory.ThyroidProfile,
  FT4: ParameterCategory.ThyroidProfile,
  VITD25OH: ParameterCategory.ObesityRelatedMetainflammation,
  PCR: ParameterCategory.ObesityRelatedMetainflammation,
  VES: ParameterCategory.ObesityRelatedMetainflammation,
  AMI: ParameterCategory.Pancreas,
  LIP: ParameterCategory.Pancreas,
  CK: ParameterCategory.MusclesAndTissues,
  PSA: ParameterCategory.Prostate,
  'A.Fol': ParameterCategory.WomanOver40,
  'PTT.sec': ParameterCategory.WomanOver40,
  'PTT.ratio': ParameterCategory.WomanOver40,
  'LH ': ParameterCategory.WomanOver40,
  FSH: ParameterCategory.WomanOver40,
  PROL: ParameterCategory.WomanOver40,
  VITD3: ParameterCategory.WomanOver40,
  'E.URI': ParameterCategory.UrineTest,
  'E.URI.COL': ParameterCategory.UrineTest,
  'E.URI.ASP': ParameterCategory.UrineTest,
  'E.URI.PS': ParameterCategory.UrineTest,
  'E.URI.PH': ParameterCategory.UrineTest,
  'E.URI.GLU': ParameterCategory.UrineTest,
  'E.URI.PRO': ParameterCategory.UrineTest,
  'E.URI.EMO': ParameterCategory.UrineTest,
  'E.URI.CHETO': ParameterCategory.UrineTest,
  'E.URI.BILI': ParameterCategory.UrineTest,
  'E.URI.URO': ParameterCategory.UrineTest,
  'E.URI.NIT': ParameterCategory.UrineTest,
  'E.URI.ERI': ParameterCategory.UrineTest,
  'E.URI.LEU': ParameterCategory.UrineTest,
  'E.URI.BATT': ParameterCategory.UrineTest,
  'E.URI.EPI': ParameterCategory.UrineTest,
  'S.FECI': ParameterCategory.BloodInTheStool,
};

export const PARAMETERS_SUB_CATEGORY: Record<string, string> = {
  EMO: ParameterSubCategory.Hemocrome,
  WBC: ParameterSubCategory.Hemocrome,
  RBC: ParameterSubCategory.Hemocrome,
  HB: ParameterSubCategory.Hemocrome,
  HCT: ParameterSubCategory.Hemocrome,
  MCV: ParameterSubCategory.Hemocrome,
  MCH: ParameterSubCategory.Hemocrome,
  MCHC: ParameterSubCategory.Hemocrome,
  RDW: ParameterSubCategory.Hemocrome,
  PLT: ParameterSubCategory.Hemocrome,
  NEU: ParameterSubCategory.Hemocrome,
  NEU_PERCENTAGE: ParameterSubCategory.Hemocrome,
  LIN: ParameterSubCategory.Hemocrome,
  LIN_PERCENTAGE: ParameterSubCategory.Hemocrome,
  MON: ParameterSubCategory.Hemocrome,
  MON_PERCENTAGE: ParameterSubCategory.Hemocrome,
  EOS: ParameterSubCategory.Hemocrome,
  EOS_PERCENTAGE: ParameterSubCategory.Hemocrome,
  BAS: ParameterSubCategory.Hemocrome,
  BAS_PERCENTAGE: ParameterSubCategory.Hemocrome,
  QPE: ParameterSubCategory.ElectrophoreticProteinFramework,
  Alb_PERCENTAGE: ParameterSubCategory.ElectrophoreticProteinFramework,
  ALB: ParameterSubCategory.ElectrophoreticProteinFramework,
  ALFA1_PERCENTAGE: ParameterSubCategory.ElectrophoreticProteinFramework,
  ALFA1: ParameterSubCategory.ElectrophoreticProteinFramework,
  ALFA2_PERCENTAGE: ParameterSubCategory.ElectrophoreticProteinFramework,
  ALFA2: ParameterSubCategory.ElectrophoreticProteinFramework,
  BETA1_PERCENTAGE: ParameterSubCategory.ElectrophoreticProteinFramework,
  BETA1: ParameterSubCategory.ElectrophoreticProteinFramework,
  BETA2_PERCENTAGE: ParameterSubCategory.ElectrophoreticProteinFramework,
  BETA2: ParameterSubCategory.ElectrophoreticProteinFramework,
  GAMMA_PERCENTAGE: ParameterSubCategory.ElectrophoreticProteinFramework,
  GAMMA: ParameterSubCategory.ElectrophoreticProteinFramework,
  ALB_GLO: ParameterSubCategory.ElectrophoreticProteinFramework,
  FE: ParameterSubCategory.Other,
  ALT: ParameterSubCategory.Other,
  AST: ParameterSubCategory.Other,
  ALP: ParameterSubCategory.Other,
  'Bili.tot': ParameterSubCategory.BilirubinaReflex,
  'Bili.dir': ParameterSubCategory.BilirubinaReflex,
  GGT: ParameterSubCategory.Other,
  'Prot.Tot': ParameterSubCategory.Other,
  CRE: ParameterSubCategory.Other,
  AZO: ParameterSubCategory.Other,
  NA: ParameterSubCategory.Other,
  K: ParameterSubCategory.Other,
  CA: ParameterSubCategory.Other,
  P: ParameterSubCategory.Other,
  CL: ParameterSubCategory.Other,
  'Col.Tot': ParameterSubCategory.Other,
  HDL: ParameterSubCategory.Other,
  LDL: ParameterSubCategory.Other,
  TRI: ParameterSubCategory.Other,
  LPA: ParameterSubCategory.Other,
  GLI: ParameterSubCategory.Other,
  INS: ParameterSubCategory.Other,
  HOMA: ParameterSubCategory.Other,
  HBA1C: ParameterSubCategory.Other,
  'A.URI': ParameterSubCategory.Other,
  OMO: ParameterSubCategory.Other,
  TSH: ParameterSubCategory.Other,
  FT4: ParameterSubCategory.Other,
  VITD25OH: ParameterSubCategory.Other,
  PCR: ParameterSubCategory.Other,
  VES: ParameterSubCategory.Other,
  AMI: ParameterSubCategory.Other,
  LIP: ParameterSubCategory.Other,
  CK: ParameterSubCategory.Other,
  PSA: ParameterSubCategory.Other,
  'A.Fol': ParameterSubCategory.Other,
  'PTT.sec': ParameterSubCategory.PartialThromboplastinTime,
  'PTT.ratio': ParameterSubCategory.PartialThromboplastinTime,
  'LH ': ParameterSubCategory.Other,
  FSH: ParameterSubCategory.Other,
  PROL: ParameterSubCategory.Other,
  VITD3: ParameterSubCategory.Other,
  'E.URI': ParameterSubCategory.UrineTest,
  'E.URI.COL': ParameterSubCategory.UrineTest,
  'E.URI.ASP': ParameterSubCategory.UrineTest,
  'E.URI.PS': ParameterSubCategory.UrineTest,
  'E.URI.PH': ParameterSubCategory.UrineTest,
  'E.URI.GLU': ParameterSubCategory.UrineTest,
  'E.URI.PRO': ParameterSubCategory.UrineTest,
  'E.URI.EMO': ParameterSubCategory.UrineTest,
  'E.URI.CHETO': ParameterSubCategory.UrineTest,
  'E.URI.BILI': ParameterSubCategory.UrineTest,
  'E.URI.URO': ParameterSubCategory.UrineTest,
  'E.URI.NIT': ParameterSubCategory.UrineTest,
  'E.URI.ERI': ParameterSubCategory.UrineTest,
  'E.URI.LEU': ParameterSubCategory.UrineTest,
  'E.URI.BATT': ParameterSubCategory.UrineTest,
  'E.URI.EPI': ParameterSubCategory.UrineTest,
};
